module.exports = __webpack_public_path__ + "img/log.3ea257a6.svg";